import React from "react";
import { sendEmailComission } from "../go1/emailComission";
import bymoLogo from "../img/bymo.png";

const Import = () => {
    const handleTestEmail = async () => {
        try {
            await sendEmailComission({
                recipientEmail: "stefanparasca@gmail.com",
                orderNumber: "12345",
                comisionAmount: "100",
            });
            console.log("Test email sent successfully.");
        } catch (error) {
            console.error("Error sending test email:", error.message);
        }
    };

    return (
        <div className="import-page" style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
            <h1>Import Data</h1>
            <p>Welcome to the Import page! This is where you can import your data.</p>
            <button
                onClick={handleTestEmail}
                style={{
                    padding: "10px 20px",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    border: "none",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginBottom: "20px",
                }}
            >
                Test Email
            </button>
            <div
                style={{
                    border: "1px solid #ddd",
                    borderRadius: "20px",
                    padding: "20px",
                    backgroundColor: "#f9f9f9",
                    maxWidth: "600px",
                    margin: "0 auto",
                }}
            >
                <img src={bymoLogo} alt="BYMO Logo" className="logo-user-login" />

                <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#333" , marginBottom: "20px"}}>
                    Felicitări! Ai generat o comandă care îți aduce un comision de <b>100 lei</b>.
                </p>
                <div style={{ textAlign: "center", marginTop: "50px", marginBottom: "20px"}}>
                    <a
                        href="https://bymo.live"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            textDecoration: "none",
                            color: "#fff",
                            backgroundColor: "#282828",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            fontSize: "16px",
                        }}
                    >
                        Vezi mai multe pe Platforma BYMO Athletes
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Import;
